import { observer } from "mobx-react-lite"
import { PersonalCardProps, PersonalItemCardType } from "./types"
import styled from "~/ui/styled"
import React, { useState, useCallback } from "react"
import { Alert, View } from "~/ui/primitives"
import { staticUrl } from "~utils"
import { useStores } from "~models"
// import { Evaluate } from "~components/evaluate"
// import { toJS } from "mobx"
import Clipboard from "~/ui/clipboard"
import {
  ChatTypes,
  Event,
  EventNames,
  FLAG_ACK,
  // FLAG_REPLY,
  FriendCommonData,
  FriendStatus,
} from "~proto"
import useNavigation from "~hooks/useNavigation"
// import { useModal } from "~hooks/useModal"
import { prompt } from "~utils/prompt"
// import { alertError } from "~utils/alert"
import Profile from "./components/profile"
// import Item from "./components/item"
import {
  BetweenFlex,
  Text,
  Button,
  IconFont,
  CenterFlex,
  StartFlex,
  ColumnFlex,
} from "~components/El"
import { usePopup } from "~hooks/usePopup"
import Picker from "~components/Picker"
// import QrCodeCard from "~components/qrcode-card"
// import { DialogShareContent } from "~components/PopupComponents"
import useGroupActions from "~hooks/useGroupActions"
import { globalToast } from "~utils"

/** 阅后即焚时长选项（秒）；与服务端 burning_timer 一致 */
const BURNING_TIMER_OPTIONS: { label: string; value: number }[] = [
  { label: "关闭", value: 0 },
  { label: "5秒", value: 5 },
  { label: "10秒", value: 10 },
  { label: "15秒", value: 15 },
  { label: "30秒", value: 30 },
  { label: "1分钟", value: 60 },
  { label: "1小时", value: 3600 },
  { label: "6小时", value: 21600 },
  { label: "12小时", value: 43200 },
  { label: "1天", value: 86400 },
  { label: "3天", value: 259200 },
  { label: "7天", value: 604800 },
]

function burningTimerSummary(seconds: number | null | undefined, isBurning: boolean | null | undefined): string {
  if (isBurning !== true || seconds == null || seconds <= 0) return "关闭"
  const hit = BURNING_TIMER_OPTIONS.find((o) => o.value === seconds)
  return hit?.label ?? `${seconds}秒`
}

// style
const Container = styled.View`
  flex-direction: column;
  flex: 1;
  background-color: ${({ theme }) => theme.colors.blockBackground};
`
const PersonalCardBox = styled.View`
  padding: 0 15px;
`

const ItemRow = styled.Pressable`
  width: 100%;
`

const Item: React.FC<any> = ({
  titleIcon = "",
  title = "",
  titleColor = "text",
  Extra = null,
  onClick = null,
}) => {
  const Wrap = onClick ? ItemRow : View
  return (
    <Wrap onClick={onClick || undefined} style={{ width: "100%" }}>
      <BetweenFlex
        width="100%"
        height={48}
        style={{
          borderBottomWidth: 1,
          borderBottomColor: "#e3e6ec",
        }}
      >
        <StartFlex gap="5px">
          {titleIcon && <IconFont name={titleIcon} color={titleColor} size={16} />}
          <Text fontSize="14px" color={titleColor}>
            {title}
          </Text>
        </StartFlex>
        <StartFlex minWidth={'max-content'} height="auto" width="auto">{Extra}</StartFlex>
      </BetweenFlex>
    </Wrap>
  )
}

// page
const PersonalCard: React.FC<PersonalCardProps> = ({
  userId,
  isSendMessageButtonVisible = true,
}) => {
  const navigation = useNavigation()
  const {
    userStore,
    contactStore,
    friendStore,
    chatStore,
    blackListStore,
    eventStore,
    apiStore,
  } = useStores()
  // const { Dialog } = useModal()
  const popup = usePopup()
  const { handleAddFriend } = useGroupActions()
  const [visible, setVisible] = useState(false)
  const [loading, setLoading] = useState(false)
  // const chat = chatStore.getPrivateChatByUserID(userId)
  const user = userStore.users.get(`${userId}`)
  const isBlack = !!blackListStore.black_list.get(`${userId}`)

  if (!user) return null
  const contact = contactStore.byUserId(userId)
  const friend = friendStore.friendsByUserId(userId)
  friend && friendStore.onRead(friend.id)
  // console.log("--user--", user)
  // const isOpenEvaluate = true
  // console.log("friend", friend)
  // console.log("contact", contact)

  const onPressFn = useCallback((type: PersonalItemCardType) => {
    const typeList = {
      [PersonalItemCardType.SETUP]: () => {
        navigation.push("UpdateContact", { userId: userId })
      },

      [PersonalItemCardType.EVALUATE]: () => {
        setVisible(true)
      },

      [PersonalItemCardType.TRANSFER]: () => {
        navigation.push("Transfer", { userID: userId })
      },

      [PersonalItemCardType.REPORT]: () => {
        navigation.push("Accusation", { userId: userId })
      },

      [PersonalItemCardType.BLACKLIST]: () => {
        !isBlack
          ? prompt({
              title: `是否将${user.name}加入黑名单`,
              message: "被加入黑名单的用户将无法向您发送消息",
              onSuccess: () => {
                blackListStore.addBlacklist(userId)
              },
            })
          : blackListStore.removeBlacklist(userId)
      },
      [PersonalItemCardType.MUTE]: () => {
        // eslint-disable-next-line no-unused-expressions
        !isBlack
          ? prompt({
              title: `是否将${user.name}消息免打扰`,
              message: "被消息免打扰的用户向您发送消息将静默消息提示",
              onSuccess: () => {
                // blackListStore.addBlacklist(userId)
              },
            })
          : // eslint-disable-next-line @typescript-eslint/no-empty-function
            () => {}
      },

      [PersonalItemCardType.ACCEPT]: () => {
        setLoading(true)
        const evt = new Event<FriendCommonData>(EventNames.FRIEND_APPROVE, {
          username: user.username,
          user_id: user.id
        })
        eventStore.publish(evt, { flags: FLAG_ACK })
        setLoading(false)
        navigation.navigate("ContactList")
        globalToast.show("已接受")
      },

      [PersonalItemCardType.SEND_MSG]: () => {
        apiStore.getChatRoomId({ username: user.username }).then((res) => {
          const room = res?.data as
            | {
                id: number
                chat_id: string
                title?: string
                image?: string
                is_mute?: boolean
                creator_id?: number
              }
            | undefined
          if (room?.id && room?.chat_id) {
            let chat = chatStore.getChat(room.chat_id)
            if (!chat) {
              chat = chatStore._putChat({
                id: room.id,
                chat_id: room.chat_id,
                title: room.title || user.displayName || user.name || "",
                type: ChatTypes.PRIVATE,
                creator_id: room.creator_id ?? userStore.currentUser.id,
                receiver_id: user.id,
                image: room.image,
                is_mute: room.is_mute,
              })
            }
            if (!chat) {
              globalToast.show("无法打开会话")
              return
            }
            chatStore.setCurrent(chat)
            navigation.push("Chat", { chat_id: chat.chat_id, name: chat.title })
          } else {
            const chat = chatStore.newPrivateChat({
              receiver_id: user.id,
              name: user.displayName,
            })
            chatStore.setCurrent(chat)
            navigation.push("Chat", { chat_id: chat.chat_id, name: chat.title })
          }
        })
      },

      [PersonalItemCardType.ADD]: () => {
        setLoading(true)
        handleAddFriend({
          username: user.username,
          user_id: user.id
        }).then(data => {
          globalToast.show("已发送")
          setLoading(false)
          navigation.navigate("ContactList")
          globalToast.show("已发送")
        }).catch(error => {
          globalToast.show(error?.message || "发送失败")
          setLoading(false)
        })
      },
    }
    typeList[type]()
  }, [])

  const privateChat = chatStore.getPrivateChatByUserID(userId)
  const burningSeconds =
    privateChat?.is_burning === true && privateChat?.burning_timer != null && privateChat.burning_timer > 0
      ? privateChat.burning_timer
      : 0

  const resolvePrivateChatForBurning = useCallback(async () => {
    let chat = chatStore.getPrivateChatByUserID(user.id)
    if (chat?.id != null) return chat

    const res = await apiStore.getChatRoomId({ username: user.username })
    const room = res?.data as
      | {
          id: number
          chat_id: string
          title?: string
          image?: string
          is_mute?: boolean
          creator_id?: number
        }
      | undefined
    if (room?.id && room?.chat_id) {
      let next = chatStore.getChat(room.chat_id)
      if (!next) {
        next = chatStore._putChat({
          id: room.id,
          chat_id: room.chat_id,
          title: room.title || user.displayName || user.name || "",
          type: ChatTypes.PRIVATE,
          creator_id: room.creator_id ?? userStore.currentUser.id,
          receiver_id: user.id,
          image: room.image,
          is_mute: room.is_mute,
        })
      }
      return next ?? null
    }
    return (
      chat ??
      chatStore.newPrivateChat({
        receiver_id: user.id,
        name: user.displayName,
      })
    )
  }, [apiStore, chatStore, user.displayName, user.id, user.name, user.username, userStore.currentUser.id])

  const applyBurningTimer = useCallback(
    async (seconds: number) => {
      try {
        const chat = await resolvePrivateChatForBurning()
        // 私聊用确定性的 cid 即可同步（消息收发与开关接收端都按 chat_cid 兜底），
        // 不依赖需重启才同步回来的服务端数字 id，避免新加好友发完消息后仍提示“请先发起聊天”
        if (!chat?.chat_id) {
          globalToast.show("暂时无法同步会话，请先与对方发起聊天后再试")
          return
        }
        const on = seconds > 0
        await chat.publicSwitchBurningChat(on, seconds)
      } catch {
        globalToast.show("设置失败，请稍后重试")
      }
    },
    [resolvePrivateChatForBurning],
  )

  // const showVisible = (show) => setVisible(show)

  
 
  // const [isEnabled, setIsEnabled] = useState(false)
  // const toggleSwitch = () => setIsEnabled((previous) => !previous)
  return (
    <Container>
      <Profile
        contactName={contact?.name}
        avatar={staticUrl(user?.avatar || "")}
        name={user?.name}
        atUsername={user?.atUsername}
        last_seen={user?.last_seen}
        online={user?.online}
        desc={user?.desc}
      />

      {contact && isSendMessageButtonVisible && (
        <CenterFlex height="auto" width="100%" py="10px">
          <Button
            width={140}
            height={40}
            borderRadius="6px"
            bg="rgba(7, 193, 96, 0.1)"
            onClick={() => onPressFn(PersonalItemCardType.SEND_MSG)}
          >
            <CenterFlex height="auto"  flex={1} gap="4px">
              <IconFont name="lt" size={20} color={"primary"} />
              <Text color="primary" fontSize="16px">
                发消息
              </Text>
            </CenterFlex>
          </Button>
        </CenterFlex>
      )}

      {friend && friend.status === FriendStatus.PENDING && (
        <CenterFlex width="100%" py="10px">
          <Button
            width={140}
            height={40}
            borderRadius="6px"
            bg="rgba(7, 193, 96, 0.1)"
            loading={loading}
            disabled={loading}
            onClick={() => onPressFn(PersonalItemCardType.ACCEPT)}
          >
            <CenterFlex flex={1} gap="4px">
              <IconFont name="lt" size={20} color={"primary"} />
              <Text color="primary" fontSize="16px">
                接受邀请
              </Text>
            </CenterFlex>
          </Button>
        </CenterFlex>
      )}

      {!contact && (!friend || friend?.status !== FriendStatus.PENDING) && user.id !== userStore.currentUser.id && (
        <CenterFlex width="100%" py="10px">
          <Button
            width={140}
            height={40}
            borderRadius="6px"
            bg="rgba(7, 193, 96, 0.1)"
            onClick={() => onPressFn(PersonalItemCardType.ADD)}
            loading={loading}
            disabled={loading}
          >
            <CenterFlex flex={1} gap="4px">
              <IconFont name="lt" size={20} color={"primary"} />
              <Text color="primary" fontSize="16px">
                邀请加入好友
              </Text>
            </CenterFlex>
          </Button>
        </CenterFlex>
      )}

      <PersonalCardBox>
        <Item
          title="手机号"
          Extra={
            user?.phone ? (
              <Text fontSize="14px" color="secondaryText">
                {user?.phone}
              </Text>
            ) : null
          }
        />
        <Item
          title="用户ID"
          Extra={
            user?.username ? (
              <Button
                onClick={() => {
                  Clipboard.setString(user?.username)
                  Alert.alert("复制成功")
                }}
              >
                <CenterFlex gap="6px">
                  <Text fontSize="14px" color="primaryText">
                    @{user?.username}
                  </Text>
                  <IconFont name="copy" size={14} color={"primaryText"} />
                </CenterFlex>
              </Button>
            ) : null
          }
        />
        {/* <Item
          title="置顶聊天"
          titleIcon="copy"
          Extra={<Switch value={isEnabled} onValueChange={toggleSwitch} />}
        />
        <Item
          title="消息免打扰"
          titleIcon="Union"
          Extra={<Switch value={isEnabled} onValueChange={toggleSwitch} />}
        /> */}
        {user.id !== userStore.currentUser.id ? (
          <Item
            title="阅后即焚"
            titleIcon="jilu"
            onClick={() => {
              const p = popup.open({
                type: "bottom",
                content: (
                  <Picker
                    title="阅后即焚"
                    options={BURNING_TIMER_OPTIONS}
                    value={burningSeconds}
                    onChange={(v: number) => {
                      popup.close(p.id)
                      applyBurningTimer(typeof v === "number" ? v : Number(v))
                    }}
                  />
                ),
              })
            }}
            Extra={
              <CenterFlex gap="6px">
                <Text fontSize="14px" color="secondaryText">
                  {burningTimerSummary(privateChat?.burning_timer, privateChat?.is_burning)}
                </Text>
                <IconFont name="right" size={14} color={"secondaryText"} />
              </CenterFlex>
            }
          />
        ) : null}
        <Item
          title="查找聊天内容"
          titleIcon="ss"
          onClick={() => {
            const cid = chatStore.getPrivateChatByUserID(userId)?.chat_id
            if (!cid) {
              globalToast.show("暂无会话")
              return
            }
            navigation.navigate("SearchChatContent", { chat_cid: cid })
          }}
          Extra={<IconFont name="right" size={14} color={"secondaryText"} />}
        />
        {/* <Item
          title="清空聊天记录"
          titleIcon="Vector"
          titleColor="danger"
          onClick={() => {
            setMessageModal({
              visible: true,
              extra: {
                message: "确定要清空与该联系人的所有聊天记录吗？此操作不可恢复。",
                title: "清空聊天记录",
                onConfirm: () => {
                },
                onCancel: () => {
                },
              },
            })
          }}
        /> */}
        {/* <Item
          title="共同群聊"
          titleIcon="cjql"
          Extra={
            <Button onClick={() => {}}>
              <CenterFlex gap="6px">
                <Text fontSize="14px" color="secondaryText">
                  3人
                </Text>
                <IconFont name="copy" size={14} color={"secondaryText"} />
              </CenterFlex>
            </Button>
          }
        /> */}
        {/* <Item
          title="分享联系人"
          titleIcon="ss"
          onClick={() => {
            Dialog.show({
              title: "温馨提示",
              content: React.createElement(DialogShareContent, {
                content: "已将“吴东弟”的名片分享给",
                subContent: "兆云",
                avatarProps: {
                  size: 36,
                  name: 'ceshi001'
                }
              }),
              onConfirm: () => {
              },
            })
          }}
        /> */}
        <ColumnFlex
          width="100%"
          mt="10px"
          gap="10px"
          padding="15px 10px"
          bg="#fff7ed"
          borderRadius="8px"
        >
          <Text color="#9a3412" fontSize="14px" fontWeight="600">
            安全提示
          </Text>
          <Text color="#9a3412" fontSize="12px">
            请注意保护个人隐私，不要向陌生人透露个人信息及财产情况
          </Text>
        </ColumnFlex>
        {/* {contact && (
          <Item
            title="设置备注"
            onClick={() => onPressFn(PersonalItemCardType.SETUP)}
            type={PersonalCardType.MOVE}
            icon={<Icon name={"setup"} size={16} color={"#07c160"} />}
          />
        )} */}
        {/* {isOpenEvaluate && (
          <Item
            title="信用及评价"
            onClick={() => onPressFn(PersonalItemCardType.EVALUATE)}
            type={PersonalCardType.MOVE}
            icon={<Icon name={"evaluate"} size={16} color={"#07c160"} />}
          />
        )} */}

        {/* {configStore.wallet_on && (
          <Item
            title="转账"
            onClick={() => onPressFn(PersonalItemCardType.TRANSFER)}
            type={PersonalCardType.MOVE}
            icon={<Icon name={"transfer"} size={16} color={"#07c160"} />}
          />
        )} */}
        {/* <Item
          title="举报此用户"
          onClick={() => onPressFn(PersonalItemCardType.REPORT)}
          type={PersonalCardType.MOVE}
          icon={<Icon name={"report"} size={16} color={"#07c160"} />}
        /> */}
        {/* <Item
          isBlack={isBlack}
          title="加入黑名单"
          onClick={() => onPressFn(PersonalItemCardType.BLACKLIST)}
          type={PersonalCardType.SWITCH}
          icon={<Icon name={"blacklist"} size={16} color={"#07c160"} />}
        /> */}
        {/* <Item
          isBlack={isBlack}
          title="消息免打扰"
          onClick={() => onPressFn(PersonalItemCardType.MUTE)}
          type={PersonalCardType.SWITCH}
          icon={<Icon name={"bellOffOutline"} size={16} color={"#07c160"} />}
        /> */}
        {/* {friend && friend.status === FriendStatus.PENDING && (
          <Item
            title="接受邀请"
            onClick={() => onPressFn(PersonalItemCardType.ACCEPT)}
            type={PersonalCardType.ACCEPT}
          />
        )} */}

        {/* {!contact &&
          (!friend || friend?.status !== FriendStatus.PENDING) &&
          user.id !== userStore.currentUser.id && (
            <Item
              title="添加到通讯录"
              onClick={() => onPressFn(PersonalItemCardType.ADD)}
              type={PersonalCardType.ADD}
            />
          )} */}
      </PersonalCardBox>
      {/* <Evaluate visible={visible} showVisible={showVisible} user_id={user?.id} /> */}
    </Container>
  )
}

export default observer(PersonalCard)
